'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _I18n3 = require('I18n.React');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _QuickReplyGroup = require('ui-addon-conversations/components/QuickReplyGroup');

var _QuickReplyGroup2 = _interopRequireDefault(_QuickReplyGroup);

var _SenderName = require('ui-addon-conversations/components/SenderName');

var _SenderName2 = _interopRequireDefault(_SenderName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageFooter = _react2.default.createClass({
  displayName: 'MessageFooter',

  propTypes: {
    message: _react.PropTypes.object.isRequired,
    allMessages: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    responder: _react.PropTypes.instanceOf(_immutable.Record),
    messageRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
    currentRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
    isLastInGroup: _react.PropTypes.bool,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired,
    readOnly: _react.PropTypes.bool.isRequired,
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func
  },

  hasQuickReplyOptions: function hasQuickReplyOptions() {
    var _props = this.props,
        message = _props.message,
        messageRole = _props.messageRole,
        currentRole = _props.currentRole;


    return (0, _ConversationalMessageModel.getQuickReply)(message) && messageRole === _RoleTypes2.default.REP && currentRole === _RoleTypes2.default.VISITOR;
  },
  hasBeenAnswered: function hasBeenAnswered() {
    var _props2 = this.props,
        message = _props2.message,
        allMessages = _props2.allMessages;


    var currentMessageIndex = allMessages.findIndex(function (messageAtIndex) {
      return messageAtIndex.equals(message);
    });

    var nextMessage = allMessages.get(currentMessageIndex + 1);

    var hasQuickReplyResponse = nextMessage && (0, _ConversationalMessageModel.getQuickReply)(nextMessage);

    var allowUserInput = (0, _ConversationalMessageModel.getAllowUserInput)(message);

    return nextMessage && (hasQuickReplyResponse || allowUserInput);
  },
  shouldRenderQuickReply: function shouldRenderQuickReply() {
    return this.hasQuickReplyOptions() && !this.hasBeenAnswered();
  },
  handleSend: function handleSend(text, options) {
    var _props3 = this.props,
        message = _props3.message,
        publishMessage = _props3.publishMessage;


    publishMessage({
      text: text,
      quickReply: _extends({}, message.metadata.quickReply, {
        quickReplies: options
      })
    });
  },
  handleSendMulti: function handleSendMulti(options) {
    var text = options.join(', ');

    this.handleSend(text, options);
  },
  handleSendIndividual: function handleSendIndividual(text) {
    var options = [text];

    this.handleSend(text, options);
  },
  renderFailedMessage: function renderFailedMessage() {
    var _props4 = this.props,
        message = _props4.message,
        republishMessage = _props4.republishMessage;


    var onClick = function onClick() {
      return republishMessage(message);
    };

    return _react2.default.createElement(
      _Small2.default,
      { use: 'error' },
      _react2.default.createElement(
        _UILink2.default,
        { use: 'danger', onClick: onClick },
        _react2.default.createElement(_I18n3.FormattedHTMLMessage, { message: 'chat.status.' + message.status })
      )
    );
  },
  renderStatus: function renderStatus() {
    var message = this.props.message;

    var timestamp = (0, _PubNubMessageModel.getTimestamp)(message);

    switch (true) {
      case (0, _ConversationalMessageModel.isInitialMessage)(message):
      case (0, _ConversationalMessageModel.isOfflineMessage)(message):
      case (0, _PubNubMessageModel.isPublished)(message):
        return _I18n2.default.moment(timestamp).format('h:mma');

      case (0, _PubNubMessageModel.isUnpublished)(message):
        return _react2.default.createElement(_I18n3.FormattedHTMLMessage, { message: 'chat.status.UNPUBLISHED' });

      case (0, _PubNubMessageModel.isPublishFailed)(message):
        return this.renderFailedMessage();

      default:
        return null;
    }
  },
  renderQuickReplyGroup: function renderQuickReplyGroup() {
    var _props5 = this.props,
        metadata = _props5.message.metadata,
        coloring = _props5.coloring;
    var _metadata$quickReply = metadata.quickReply,
        quickReplies = _metadata$quickReply.quickReplies,
        allowMultiSelect = _metadata$quickReply.allowMultiSelect;


    return _react2.default.createElement(_QuickReplyGroup2.default, {
      options: quickReplies,
      multiSelect: allowMultiSelect,
      hasSentReply: false,
      coloring: coloring,
      onSendMulti: this.handleSendMulti,
      onSendIndividual: this.handleSendIndividual
    });
  },
  renderContent: function renderContent() {
    if (this.shouldRenderQuickReply()) {
      return this.renderQuickReplyGroup();
    }

    return _react2.default.createElement(
      'span',
      null,
      this.renderName(),
      this.renderStatus()
    );
  },
  renderName: function renderName() {
    var _props6 = this.props,
        currentRole = _props6.currentRole,
        messageRole = _props6.messageRole,
        responder = _props6.responder;


    if (!responder) return null;

    return _react2.default.createElement(_SenderName2.default, {
      currentRole: currentRole,
      messageRole: messageRole,
      responder: responder
    });
  },
  render: function render() {
    var _props7 = this.props,
        messageRole = _props7.messageRole,
        currentRole = _props7.currentRole,
        isLastInGroup = _props7.isLastInGroup,
        message = _props7.message;


    if (!isLastInGroup && (0, _PubNubMessageModel.isPublished)(message)) {
      return null;
    }

    var className = (0, _reactUtils.classNames)('chat-message-timestamp', {
      'text-right p-right-1': messageRole === currentRole,
      'text-left p-left-1': messageRole !== currentRole
    });

    return _react2.default.createElement(
      _Small2.default,
      { className: className },
      this.renderContent()
    );
  }
});

exports.default = MessageFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/MessageFooter.js
// module id = 400
// module chunks = 0 1